/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Nav_CompareInputs */

const en_pc_nav_compare = /** @type {(inputs: Pc_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Photoshop`)
};

const zh_pc_nav_compare = /** @type {(inputs: Pc_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比 Photoshop`)
};

/**
* | output |
* | --- |
* | "vs Photoshop" |
*
* @param {Pc_Nav_CompareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_nav_compare = /** @type {((inputs?: Pc_Nav_CompareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Nav_CompareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_nav_compare(inputs)
	return zh_pc_nav_compare(inputs)
});
export { pc_nav_compare as "pc.nav.compare" }